import { Injectable } from '@angular/core';
import { AlarmService } from './alarm.service';
import { DeviceTokenService } from './device-token.service';

@Injectable()
export class PushService {

  /**
   * 현재 디바이스 토큰
   * @type {?string}
   */
  private $token: string = null;

  constructor(
      private $alarmService: AlarmService,
      private $deviceTokenService: DeviceTokenService) {}

  /**
   * 디바이스 토큰 등록 여부를 확인하고 등록.
   * @return {Promise}
   */
  private async registerDevice() {

    if (!this.$token) return;

    // 사용자 정보로 디바이스 토큰 등록 여부 반환.
    const device = await this.$deviceTokenService.hasDeviceToken();

    // 디바이스 토큰 등록 및 업데이트
    this.$deviceTokenService.registerDeviceToken(this.$token).subscribe();

    // 디비에 저장된 토큰이 있고 현재 토큰과 다르다면 사용자가 설정한 알람 초기화
    if (device && this.$token !== device.token) {
      this.$alarmService.clearAlarms();
    }
  }

  /**
   * 디바이스 토큰 등록
   */
  register() {
    this.registerDevice().
        catch(err => console.log('Register device error', err));
  }

  /**
   * 디바이스 토큰 반환
   * @return {string}
   */
  getKey(): string {
    return this.$token;
  }

  /**
   * 디바이스 토큰 저장
   * @param {string}
   */
  setKey(key: string) {
    this.$token = key;
  }
}
